module.exports = __webpack_public_path__ + "img/global-currency-conversion.c7c5a9b1.svg";